/*** IMPORTS FROM imports-loader ***/
var define = false;

var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

